import React from 'react';
import { TextLabel } from '../../design-system/texts';
import { FlexDiv } from '../../design-system/containers';
import { useTranslation } from 'react-i18next';
import EmailTrans from '../email-i18next-trans';

const EmailFooter = ({
    footer,
    handleLinkClick,
    handleLinkMouseLeave,
    handleLinkMouseEnter,
    link,
}) => {
    const { t } = useTranslation('assessment');
    /** footer key can either be defined within a footer object, or as a standalone key */
    const footerTranslationKey = footer.text || footer;
    /** footer text is by default lighter than regular text, but this can be disabled in definition */
    const useLighterText = !footer.disableDefaultOpacity;

    return (
        <FlexDiv pt={16} borderTop>
            <TextLabel lighter={useLighterText}>
                <EmailTrans
                    translatedString={t(footerTranslationKey)}
                    link={link}
                    linkFunctionality={{
                        handleLinkClick,
                        handleLinkMouseLeave,
                        handleLinkMouseEnter,
                    }}
                />
            </TextLabel>
        </FlexDiv>
    );
};

export default EmailFooter;
